module.exports = __webpack_public_path__ + "static/img/en_logo.6b835fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/en_logo.jpg
// module id = NGyk
// module chunks = 29